import { authQuery } from "../baseQuery";
import { SignInRequest, SignInResponse } from "./models";

const signIn = (params: SignInRequest) =>
  authQuery.post<SignInResponse>("/web_auth", params);

export const AuthService = {
  signIn,
};
